/**
 * @name                                    format.d.ts
 * @description                             Definitions for the `format` module
*/


/* ---------------------------------------- PACK ----------------------------------------  */

    import { t_style }             from '@je-es/ansi';

/* ---------------------------------------- ---- ----------------------------------------  */


/* ---------------------------------------- INIT ----------------------------------------  */

    export type t_padding =
    {
        top         ?: number,
        bottom      ?: number,
        left        ?: number,
        right       ?: number,
    };

    export type t_prefix =
    {
        value       : string,
        style       : t_style,
    }

    export type t_border =
    {
        width       ?: number,
        color       ?: string,
    };

    export type formatOptions =
    {
        ansi        ?: t_style,
        padding     ?: t_padding,
        border      ?: t_border,
        prefix      ?: t_prefix,
        suffix      ?: t_prefix,
        width       ?: number,
        align       ?: 'left' | 'center' | 'right',
    }

    export type borderDimensions =
    {
        topBeg     : string,
        topEnd     : string,

        botBeg     : string,
        botEnd     : string,

        char       : string,
        side       : string,
    };

    export type t_pattern =
    [{
        value       ?: string,
        gvalue      ?: string,
        options     : formatOptions,
    }[]];

    export { t_style };

/* ---------------------------------------- ---- ----------------------------------------  */